import { DEFAULT_VALUE_IF_NIL, FEIN_MASK } from '@clearverify/constants';
export const formatWithMask = (value, mask) => {
    let i = 0;
    const v = value?.toString() || '';
    return mask.replace(/#/g, _ => {
        i += 1;
        return v[i - 1] || '';
    });
};
export const formatFeinNumber = (feinNumber) => {
    if (!feinNumber)
        return null;
    return formatWithMask(feinNumber, FEIN_MASK);
};
export const maskSsnNumber = (ssnNumber, filler = 'X', valueIfNil = DEFAULT_VALUE_IF_NIL) => {
    return ssnNumber ? `XXX-XX-${ssnNumber.slice(-4)}`.replace(/X/g, filler) : valueIfNil;
};
export const shuffleString = (str) => str
    .split('')
    .sort(() => 0.5 - Math.random())
    .join('');
export const stringsEqualIgnoreCase = (str1, str2) => {
    if (!str1 || !str2) {
        return false;
    }
    return str1.localeCompare(str2, undefined, { sensitivity: 'accent' }) === 0;
};
//# sourceMappingURL=string.js.map